import * as angular from "angular";
import {ApiUrl} from "../../models/app-config.model";
import {TitleToRoleConfiguration} from "../../models/title-to-role-configuration.model";
import {RuleConfigCommand} from "../../models/command/rule-config-command.model";

export interface ConfigurationService {
    getTitleToRoleConfiguration: (districtId: string) => angular.IPromise<TitleToRoleConfiguration>;
    saveTitleToRoleConfiguration: (roleConfigCommand: RuleConfigCommand) => angular.IPromise<number>;
}

/* @ngInject */
export function configurationService($http: angular.IHttpService, API_URL: ApiUrl,
        $cacheFactory: angular.ICacheFactoryService): ConfigurationService {
    let configurationCache = $cacheFactory("configurationCache");

    return {
        getTitleToRoleConfiguration: (districtId: string): angular.IPromise<TitleToRoleConfiguration> => {
            return $http.get(`${API_URL.titleToRoleConfiguration.replace(/\:districtId/, districtId)}`,
                { cache: configurationCache })
                .then((response: {data: TitleToRoleConfiguration}) => {
                    return response.data;
                });
        },

        saveTitleToRoleConfiguration: (ruleConfigCommand: RuleConfigCommand): angular.IPromise<number> => {
            return $http.post(`${API_URL.saveTitleToRoleConfiguration}`, ruleConfigCommand)
                .then((response: {status: number}) => {
                    configurationCache.removeAll();
                    return response.status;
                });
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/configuration/configuration.service.ts